<div class="modal-body">
    <div class="modal-body-container">
      <ng-content></ng-content>
    </div>
  </div>
  